import { Pipe, PipeTransform } from '@angular/core';
import { slugify } from '@nx-monorepo/obce/common/utils';

@Pipe({
  name: 'DetailUrl',
  pure: false
})
export class DetailUrlPipe implements PipeTransform {
  transform(value: string, entity?: string, category?: string): any {
    if(value !== null) {
      let returnString = '/';
      if (entity) {
        returnString += slugify(entity) + '/';
      }
      if (category) {
        returnString += slugify(category) + '/';
      }
      return returnString + slugify(value);
    }
  }
}
